
<div class="add-finding-type">
  <form class="add-finding-type__form" [formGroup]="addFindingTypeForm" novalidate="novalidate" autocomplete="off">
    <div class="add-finding-type__fieldset">
      <div class="row add-finding-type__fields">
        <div class="columns small-12 small-centered">
          <div class="form__field--lower add-finding-type__field" [class.form__field--error]="isFieldInvalid(addFindingTypeForm.controls['name'])">
            <label class="label add-finding-type__field-label" for="name">{{ 'ADMIN_SETTINGS.FINDING_TYPES.MODAL.FORM.LABEL.NAME' | translate }}</label>
            <div class="form-field__error">{{ 'ADMIN_SETTINGS.FINDING_TYPES.MODAL.FORM.ERROR.NAME_EMPTY' | translate }}</div>
            <input class="input" placeholder="{{ 'ADMIN_SETTINGS.FINDING_TYPES.MODAL.FORM.PLACEHOLDER.NAME' | translate }}" type="text" id="name" name="name" [formControl]="addFindingTypeForm.controls['name']"/>
          </div>
          <div class="form__field--lower add-finding-type__field" [class.form__field--error]="isFieldInvalid(addFindingTypeForm.controls['description'])">
            <label class="label add-finding-type__field-label" for="description">{{ 'ADMIN_SETTINGS.FINDING_TYPES.MODAL.FORM.LABEL.DESCRIPTION' | translate }}</label>
            <div class="form-field__error">{{ 'ADMIN_SETTINGS.FINDING_TYPES.MODAL.FORM.ERROR.DESCRIPTION_EMPTY' | translate }}</div>
            <div class="textarea-container">
              <textarea class="textarea--small textarea--autosize" gwAutosize="gwAutosize" rows="1" id="description" name="description" placeholder="{{ 'ADMIN_SETTINGS.FINDING_TYPES.MODAL.FORM.PLACEHOLDER.DESCRIPTION' | translate }}" [formControl]="addFindingTypeForm.controls['description']">{{ addFindingTypeForm.controls['description'].value }}</textarea>
              <div class="textarea-border"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>